module.exports = __webpack_public_path__ + "img/reward-mobile.2748400f.png";